// allow overriding the API server via environment variable for local/dev testing
// In Create React App use a .env file with REACT_APP_REST_API_SERVER
export const REST_API_SERVER = process.env.REACT_APP_REST_API_SERVER || "https://api.eebac.com/api";

export const BRAND_NAME = "Eebac";
export const MENU_LABEL = "Navigation Menu";

export const AUTH_TOKEN_KEY = "j_t";
export const AUTH_RTOKEN_KEY = "j_r";
export const AUTH_USER_KEY = "a_u";
export const CONFIG_OTP_RESEND_ATTEMPTS = 5;

export const USER_TYPE = {
    COMPANY: 'company',
    VENDOR: 'vendor'
}

export const ROLE_TYPE = {
    COMPANY: "role_company",
    COMPANY_CONTRACTS: "role_contract",
    COMPANY_HR: "role_hr",
    VENDOR: "role_vendor",
    CANDIDATE: "role_candidate"
}

export const VALIDATION_MESSAGES = {
    REQUIRED: 'This field is required',
    INVALID: 'Invalid value',
    INVALID_ONLY_ALPHA_ALLOWED: 'Only alphabets allowed',
    PASSWORD: 'Password must contain at least 8 or at most 16 characters including UPPER/lowercase, ~ ! @ # $ % special characters and numbers',
    INVALID_ONLY_ALPHA_NUMBERS_SPACES_ALLOWED: 'Alphabets, numbers, spaces and @&(), characters are allowed',
    INVALID_ONLY_ALPHA_SPACES_ALLOWED: 'Alphabets and spaces are allowed',
    PROFILE_PHOTO: "Upload profile photo",
    FORM_SUMBIT_VALIDATION: "Please fill in all the required fields with valid information",
    INVALID_DATE: 'Invalid date',
}

export const ERROR_MESSAGES = {
    SERVER_FAULT: '',
    SAVED_SUCCESS: "Record has been saved successfully",
    INVALLID_LOGIN: "Invalid login credentials",
    PAGE_NOT_FOUND: "The page you were looking for doesn't exist",
    ONLY_IMAGES: "Only images are allowed",
    FILE_TYPE_IS_NOT_ALLOWED: "File type is not allowed",
    FILE_TYPE_IS_TOO_LARGE: "File is too large",
    FAILED_TO_LOAD_STATES: "Failed to load states data",
    FAILED_TO_LOAD_ADDRESS_PROOFS: "Failed to load address proofs data",
    FAILED_TO_LOAD_COMPANY_TYPES: "Failed to load company types",
    FAILED_TO_LOAD_FIRM_TYPES: "Failed to load firm types",
    FAILED_TO_LOAD_WORK_SCOPE_TYPES: "Failed to load work scope types",
    FAILED_TO_LOAD_WORK_TYPES: "Failed to work types",
}

export const GLOBAL_VALUES = {
    ALERT_AUTO_HIDE_TIMEOUT: 5000,
    PROFILE_AVATAR_SIZE: 256,
    DEFAULT_ADDRESS_STATE: '1',
    DEFAULT_ADDRESS_PROOF: '1',
    DEFAULT_UPLOAD_FILE_SIZE: 500,
    DEFAULT_UPLOAD_LABEL: "Drop file or click here to upload",
    DEFAULT_ROWS_PER_PAGE_ARRAY: [5, 10, 25, 50, 100],
    DEFAULT_ROWS_PER_PAGE: 10
}

export const ALERT_SEVERITY = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info'
}

export const REGEX_PATTERNS = {
    ONLY_ALPHA: /^[a-zA-Z]+$/,
    ONLY_ALPHA_SPACES: /^[a-zA-Z\s]+$/,
    MOBILE_NUMBER: /^[6-9]\d{9}$/,
    ONLY_NUMBER: /^[0-9]+$/,
    COMPANY_NAME: /^[a-zA-Z\s&0-9\(\)@,]+$/,
    LANDLINE_NUMBER: /^[0-9]\d{9,14}$/,
    GST_NUMBER: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i,
    IFSC_CODE: /^[A-Z]{4}0[A-Z0-9]{6}$/i,
    PAN: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i,
    DATE: /^\d{2}\/\d{2}\/\d{4}$/,
    PINCODE: /^[1-9][0-9]{5}$/,
    PASSWORD: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%])[0-9A-Za-z~!@#$%]{8,16}$/
}

export const PAYMENT_MESSAGES = {
    "success": "Thank you! Your payment is successful, Please wait loading invoice.",
    "failed": "We are sorry! payment was unsuccessful.",
    "aborted": "Transaction has been cancelled",
    "invalid": ERROR_MESSAGES.SERVER_FAULT,
    "timeout": "Transaction has been timed out",
    "failure" : "Payment was unsuccessful."
}